class NbCombo extends HTMLElement {
  constructor() {
    super();
    this.products = new Map();
    // Do NOT query DOM or add event listeners here!
  }

  connectedCallback() {
    // Now the element and its children are in the DOM!
    this.priceElement = this.querySelector('[js-price]');
    this.priceDiscountedElement = this.querySelector('[js-price-discounted]');
    this.addToCartButton = this.querySelector('[js-add-combo-to-cart]');

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.onAddToCartClick.bind(this));
    }

    this.addEventListener('variant-changed', this.onVariantChanged.bind(this));
  }

  disconnectedCallback() {
    if (this.addToCartButton) {
      this.addToCartButton.removeEventListener('click', this.onAddToCartClick.bind(this));
    }
    this.removeEventListener('variant-changed', this.onVariantChanged.bind(this));
  }

  onVariantChanged(event) {
    const { variant, productId } = event.detail;

    // Store the variant data
    this.products.set(productId, {
      price: variant.price,
      available: variant.available,
      id: variant.id,
    });

    this.updateTotalPrice();
    this.updateAddToCartButton();
  }

  async onAddToCartClick(event) {
    event.preventDefault();
    if (!this.addToCartButton) return;

    // Collect all variant IDs
    const items = Array.from(this.products.values()).map((product) => ({
      id: product.id,
      quantity: 1,
      properties: {
        '_related-source': 'combo',
      },
    }));

    if (items.length === 0) return;

    this.addToCartButton.setAttribute('disabled', 'disabled');
    this.addToCartButton.classList.add('loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Trigger cart update event (if available)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'nb-combo',
          cartData: data,
        });
      }

      // Update cart contents and open drawer
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        cart.renderContents(data);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      }
    } catch (error) {
      console.error('Error adding combo to cart:', error);
    } finally {
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.classList.remove('loading');
    }
  }

  updateTotalPrice() {
    if (!this.priceElement) return;

    let totalPrice = 0;
    let allAvailable = true;

    // Sum up prices from all products
    for (const [_, product] of this.products) {
      totalPrice += product.price;
      if (!product.available) {
        allAvailable = false;
      }
    }

    // Format the price
    const formattedPrice = this.formatMoney(totalPrice);
    this.priceElement.textContent = formattedPrice;

    // Calculate and display discounted price (10% off)
    if (this.priceDiscountedElement) {
      const discountedPrice = Math.round(totalPrice * 0.9);
      this.priceDiscountedElement.textContent = this.formatMoney(discountedPrice);
    }

    // Update button state
    this.updateAddToCartButton(allAvailable);
  }

  updateAddToCartButton(allAvailable = true) {
    if (!this.addToCartButton) return;

    if (allAvailable) {
      this.addToCartButton.removeAttribute('disabled');
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled');
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? decimal + parts[1] : '';

      return '$' + dollars + cents;
    }

    return formatWithDelimiters(cents, 2);
  }
}

customElements.define('nb-combo', NbCombo);
